import { useContext } from 'react';
import { ShowDrawerContext } from './context';

export const useShowDrawer = () => {
  return useContext(ShowDrawerContext);
};
